export const legacyGeneralExcelOffices = [
  { id: 'mock-office-1', name: 'Mock 지점' },
  { id: 'mock-office-2', name: 'Mock 테스트 지점' },
]

export const legacyGeneralExcelWorkgroups = ['Mock 촬영팀', 'Mock 편집팀']

export const legacyGeneralExcelHistory = [
  { no: 1, uploadedAt: '0000-00-00 00:00', staff: 'Mock 작업자' },
]

export const legacyGeneralExcelDetailHeaders = [
  'No', '*일정제목', '*일자', '*시작 시각', '*종료 시각', '*소요 시각', '작업담당 명', '작업담당 ID', '메모', '내용',
]

export const legacyGeneralExcelDetails = Array.from({ length: 4 }, (_, index) => [
  String(index + 1),
  `Mock 일정 ${index + 1}`,
  '0000-00-00',
  '00:00',
  '00:00',
  '0분',
  'Mock 작업팀',
  `MOCK-${index + 1}`,
  '비식별 Mock 메모',
  '비식별 Mock 내용',
])
